import { useState, useEffect } from 'react';

interface AnimatedDotsProps {
  interval?: number; // 애니메이션 속도 조절 가능
  className?: string; // 스타일링 옵션
}

/**
 * 애니메이션 점 3개
 * @param interval 애니메이션 속도 조절 가능 (기본 500ms)
 * @param className 스타일링 옵션
 * @returns 애니메이션 점 3개
 */
export function AnimatedDots({ interval = 500, className }: AnimatedDotsProps) {
  const [dotCount, setDotCount] = useState(1);

  useEffect(() => {
    const timer = setInterval(() => {
      setDotCount((prev) => (prev >= 3 ? 1 : prev + 1));
    }, interval);

    return () => clearInterval(timer);
  }, [interval]);

  return <span className={className}>{'.'.repeat(dotCount)}</span>;
}
